export default __webpack_public_path__ + "static/media/IMG_3066_4_11zon.0c9a72c1.jpg";